import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-branch-filter',
  templateUrl: './branch-filter.component.html',
  styleUrls: ['./branch-filter.component.scss'],
})
export class BranchFilterComponent {
  public branches = [];
  @Input() branchList = [];
  @Output() selectBranch = new EventEmitter();

  selectedBranch(branch) {
    const index = this.branches.indexOf(branch);
    if (index < 0) {
      this.branches.push(branch);
    } else {
      this.branches.splice(index, 1);
    }
    this.selectBranch.emit(this.branches);
  }
}
